import { render } from "./MatLabs.vue?vue&type=template&id=0b790470&scoped=true"
import script from "./MatLabs.vue?vue&type=script&lang=js"
export * from "./MatLabs.vue?vue&type=script&lang=js"

import "./MatLabs.vue?vue&type=style&index=0&id=0b790470&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b790470"]])

export default __exports__